export default theme => ({
  root: {
    '&.ag-theme-balham': {
      height: '60vh'
    }
  }
});